import { refreshToken } from '../actions/sessionActions';
import { diff_minutes } from '../../components/utils/functions';
import { GET_ENVIRONMENT, SET_TOKEN_DIFF } from '../constants/constants';

export const getCurrentEnvironment = (initialState) => {
    return dispatch => dispatch({ type: GET_ENVIRONMENT, environment: initialState });
}

// Función que verifica la validez del JWT
export const isJWTSessionValid = (expiration) => {
    var createdAt = new Date(expiration * 1000);
    var now = new Date();

    var diff = diff_minutes(now, createdAt);

    // Validamos que tengamos un margen de tiempo para poder refrescar el token
    if( diff + 5 >= 29 ) {
        return dispatch => dispatch(refreshToken());
    }

    return dispatch => {
        dispatch({ type: SET_TOKEN_DIFF, token_diff: diff });
    }
}
